import client from '../../client';

const DOCUMENTS = {
  getDocuments(saleId) {
    return client.get(`/buyers/${client.customerId()}/sales/${saleId}/documents`);
  }
};

export default DOCUMENTS;
